import { render, staticRenderFns } from "./videos_types.vue?vue&type=template&id=d3071dac&"
import script from "./videos_types.vue?vue&type=script&lang=js&"
export * from "./videos_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports